import { pharmacyClient } from "@/connect";

export const getProductProfitability = async (page: number, pageSize: number) => {
  return await pharmacyClient.productProfitabilityReport({
    pageNumber: page,
    pageSize: pageSize,
  });
};